module.exports = __webpack_public_path__ + "static/media/icon_ubicacion.e3b6296f.svg";